import { ModuleSelectorItem } from "../module-selector-item/ModuleSelectorItem";
import { Stack } from "@mui/material";
import { ModuleType } from "../../types/ModuleType";

export function ModuleSelector() {
    return (
        <Stack
            direction="row"
            sx={{
                background: '#22293A',
                color: 'white',
            }}
        >
            <ModuleSelectorItem type={ModuleType.OptionsTable} caption="OPTIONS TABLE"/>
            <ModuleSelectorItem type={ModuleType.PositionsAndOrders} caption="POSITIONS & ORDERS"/>
            <ModuleSelectorItem type={ModuleType.BalanceProfile} caption="BALANCE PROFILE"/>
            <ModuleSelectorItem type={ModuleType.ParametersProfile} caption="PARAMETERS PROFILE"/>
            <ModuleSelectorItem type={ModuleType.PortfolioBalancer} caption="PORTFOLIO BALANCER"/>
            <ModuleSelectorItem type={ModuleType.BalanceHistory} caption="BALANCE HISTORY"/>
            <ModuleSelectorItem type={ModuleType.Binance} caption="BINANCE"/>
        </Stack>
    );
}